export const dragElement = (elmnt) => {
  var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
  var saveMouseUp = null;
  var saveMouseMove = null;

  const header = document.getElementById("js-reorder-entries-view-header");
  if (header) {
    // if present, the header is where you move the DIV from:
    document.getElementById("js-reorder-entries-view-header").onmousedown = dragMouseDown;
  }

  // Enable dragging from region reorder panel edges (left/right/bottom) and header (top)
  enableDragOnRegionReorderPanelEdges();

  function dragMouseDown(e) {
    e = e || window.event;
    e.preventDefault();
    // get the element's current position (works with both absolute and fixed positioning)
    var rect = elmnt.getBoundingClientRect();
    pos1 = rect.left;
    pos2 = rect.top;
    // get the mouse cursor position at startup:
    pos3 = e.clientX;
    pos4 = e.clientY;
    
    saveMouseUp = document.onmouseup;
    saveMouseMove = document.onmousemove;

    document.onmouseup = closeDragElement;
    document.onmousemove = elementDrag;
  }

  function elementDrag(e) {
    e = e || window.event;
    e.preventDefault();
    // calculate the new cursor position:
    // pos1 = pos3 - e.clientX;
    // pos2 = pos4 - e.clientY;
    var deltaX = pos3 - e.clientX;
    var deltaY = pos4 - e.clientY;
    pos3 = e.clientX;
    pos4 = e.clientY;
    // set the element's new position:
   //  elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
   //  elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
   
    // set the element's new position (works with both absolute and fixed positioning):
    elmnt.style.top = (pos2 - deltaY) + "px";
    elmnt.style.left = (pos1 - deltaX) + "px";
    // update stored position for next move
    pos1 = pos1 - deltaX;
    pos2 = pos2 - deltaY;
  }

  function closeDragElement() {
    // stop moving when mouse button is released:
    document.onmouseup = saveMouseUp;
    document.onmousemove = saveMouseMove;
  }

  function enableDragOnRegionReorderPanelEdges() {
    if (!elmnt || elmnt.dataset.panelEdgeDragInitialized) { return }
    elmnt.dataset.panelEdgeDragInitialized = 'true';

    var edgeHandles = elmnt.querySelectorAll('.reorder-entries-edge-handle');
    edgeHandles.forEach((handle) => {
      handle.onmousedown = dragMouseDown;
    });
  }
};
